
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FormNameProps {
  isEditing: boolean;
  formName: string;
  setFormName: (value: string) => void;
}

export const FormName: React.FC<FormNameProps> = ({
  isEditing,
  formName,
  setFormName
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="form-name" className="font-medium">
        Nom du formulaire
      </Label>
      
      {isEditing ? (
        <Input
          id="form-name"
          value={formName}
          onChange={(e) => setFormName(e.target.value)}
          placeholder="Entrez le nom du formulaire"
          className="max-w-md"
        />
      ) : (
        <div className="text-base">{formName}</div>
      )}
    </div>
  );
};
